import { render, staticRenderFns } from "./IntakeFormSection.vue?vue&type=template&id=0b477ced&scoped=true"
import script from "./IntakeFormSection.vue?vue&type=script&lang=js"
export * from "./IntakeFormSection.vue?vue&type=script&lang=js"
import style0 from "./IntakeFormSection.vue?vue&type=style&index=0&id=0b477ced&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b477ced",
  null
  
)

export default component.exports